var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFile96(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5042 4.16666L10 4.16666C8.61929 4.16666 7.5 5.28594 7.5 6.66666L7.5 33.3333C7.5 34.714 8.61929 35.8333 10 35.8333H30C31.3807 35.8333 32.5 34.714 32.5 33.3333V13.1625L23.5042 4.16666ZM23.75 5.58749L31.0792 12.9167L25.4167 12.9167C24.4962 12.9167 23.75 12.1705 23.75 11.25V5.58749ZM30 35H10C9.07952 35 8.33333 34.2538 8.33333 33.3333L8.33333 6.66666C8.33333 5.74618 9.07952 4.99999 10 4.99999L22.9167 4.99999V11.25C22.9167 12.6307 24.036 13.75 25.4167 13.75L31.6667 13.75L31.6667 33.3333C31.6667 34.2538 30.9205 35 30 35Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5 17.0833V17.9166L12.5 17.9166V17.0833L27.5 17.0833ZM12.5 23.3333H27.5V22.5H12.5V23.3333ZM12.5 28.75H27.5V27.9166H12.5V28.75Z",
    fill: "#009FDB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile96);
export default __webpack_public_path__ + "static/media/file_96.d0a1470762c927eeff6514976e0fdaef.svg";
export { ForwardRef as ReactComponent };